import "../style.css";

function TextAndInlineUnitComponent({ value, text, posx, posy, fontSize, underScoreOrTwoDots = true }) {
  return (
    <div
      className="container-component-inline"
      style={{ top: `${posy}%`, left: `${posx}%`, position: "absolute" }}
    >
      <span className="unit overlay-text-font" style={{ fontSize: fontSize }}>
        {text}
      </span>
      {underScoreOrTwoDots ? <span  className="text overlay-text-font"   style={{ fontSize: fontSize }}>&nbsp; - &nbsp; </span> : <span  className="text overlay-text-font"   style={{ fontSize: fontSize }}>&nbsp; : &nbsp; </span>}
      <span span className="text overlay-text-font"  style={{ fontSize: fontSize }}>
        {value}
      </span>
    </div>
  );
}
export default TextAndInlineUnitComponent;
